import { css } from 'styled-components';

import { focusOutlinesStyles, getHexToRgb } from './../../../core';
import { getButtonContentElementsColor } from '../../shared-styles';

const lightBackgroundStateColorStyles = {
  gray: {
    active: css`
      background-color: ${({ theme }) => theme.color.state.dark.pressed.value};
    `,
    default: css`
      ${({ theme }) => getButtonContentElementsColor(theme.color.text.light.secondary.value)}
    `,
    disabled: css`
      ${({ theme }) => getButtonContentElementsColor(theme.color.text.light.disabled.value)};
    `,
    focus: css`
      background-color: ${({ theme }) => theme.color.state.default.focus.value};
      ${focusOutlinesStyles.dark};
    `,
    hover: css`
      background-color: ${({ theme }) => theme.color.state.default.hover.value};
    `,
  },
  primary: {
    active: css`
      background-color: ${({ theme }) => theme.color.button.iconButton.overlay.active.value};
      ${({ theme }) => getButtonContentElementsColor(theme.color.button.iconButton.fill.active.value)}
    `,
    default: css`
      ${({ theme }) => getButtonContentElementsColor(theme.color.button.iconButton.fill.enabled.value)}
    `,
    disabled: css`
      ${({ theme }) => getButtonContentElementsColor(theme.color.button.iconButton.fill.disabled.value)};
    `,
    focus: css`
      background-color: ${({ theme }) => theme.color.button.iconButton.overlay.hover.value};
      ${({ theme }) => getButtonContentElementsColor(theme.color.button.iconButton.fill.hover.value)}
      ${focusOutlinesStyles.primary};
    `,
    hover: css`
      background-color: ${({ theme }) => theme.color.button.iconButton.overlay.hover.value};
      ${({ theme }) => getButtonContentElementsColor(theme.color.button.iconButton.fill.hover.value)};
    `,
  },
};

const primaryBackgroundStateColorStyles = {
  active: css`
    background-color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.dark.value)}, 0.3)`};
  `,
  default: css`
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.light.value)}
  `,
  disabled: css`
    ${({ theme }) => getButtonContentElementsColor(`rgba(${getHexToRgb(theme.color.additional.light.value)}, 0.4)`)};
  `,
  focus: css`
    background-color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.dark.value)}, 0.2)`};
    ${focusOutlinesStyles.light};
  `,
  hover: css`
    background-color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.dark.value)}, 0.2)`};
  `,
};

const darkBackgroundStateColorStyles = {
  active: css`
    background-color: ${({ theme }) => theme.color.globalHeader.headerBlock.iconPressed.value};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)};
  `,
  default: css`
    ${({ theme }) => getButtonContentElementsColor(theme.color.globalHeader.headerBlock.iconDefault.value)}
  `,
  disabled: css`
    ${({ theme }) =>
      getButtonContentElementsColor(`rgba(${getHexToRgb(theme.color.additional.alwaysWhite.value)}, 0.4)`)};
  `,
  focus: css`
    background-color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.alwaysWhite.value)}, 0.15)`};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)};
    ${focusOutlinesStyles.light};
  `,
  hover: css`
    background-color: ${({ theme }) => `rgba(${getHexToRgb(theme.color.additional.alwaysWhite.value)}, 0.15)`};
    ${({ theme }) => getButtonContentElementsColor(theme.color.additional.alwaysWhite.value)};
  `,
};

// It was decided to use gray button styling only
// but allow to cover primary color styling in cases we do not know
const iconButtonStateStyles = {
  dark: {
    gray: darkBackgroundStateColorStyles,
    primary: primaryBackgroundStateColorStyles,
  },
  light: lightBackgroundStateColorStyles,
  primary: {
    gray: primaryBackgroundStateColorStyles,
    primary: primaryBackgroundStateColorStyles,
  },
};

export const getStateStyles = (backgroundAppearance, iconColor) => {
  return iconButtonStateStyles[backgroundAppearance][iconColor];
};
